import { FC } from "react";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";

interface FilterProps {
	exportAsExcel: () => void;
}

const Filter: FC<FilterProps> = ({ exportAsExcel }) => {
	const { t } = useTranslation();

	return (
		<div className="filter-container">
			<div className="filter-end-btn">
				<CustomButton
					label={"Excel"}
					onClick={exportAsExcel}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
